import {
  Popover,
  Transition,
  TransitionChild,
  PopoverPanel,
  PopoverBackdrop,
} from "@headlessui/react";
import React, { Fragment } from "react";

export default function CustomPopover({
  children,
  isOpen,
  headerText,
  onClose,
  panelClassName,
}) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Popover as="div" className="absolute z-50" onClose={onClose}>
          {({ open }) => (
            <>
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <PopoverBackdrop
                  onClick={onClose}
                  className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
                />
              </TransitionChild>

              <div className="fixed inset-0 overflow-y-auto z-50">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-out duration-300"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <PopoverPanel
                      className={` w-full transform rounded-lg bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all ${
                        panelClassName || "max-w-lg"
                      }`}
                    >
                      <h3 className="text-lg font-semibold leading-6 text-gray-900 dark:text-gray-100">
                        {headerText}
                      </h3>
                      {children}
                    </PopoverPanel>
                  </TransitionChild>
                </div>
              </div>
            </>
          )}
        </Popover>
      </Transition>
    </>
  );
}
